import { getPrimaryColor } from "utils/themeConfig";

import CustomLink from "../elements/custom-link";
import NextImage from "../elements/image";

import styles from "@/styles/cards.module.scss";

const LargeImageCards = ({ data }) => {
  const arrow = (
    <svg
      className="inline-block"
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.41785 10.0002L5.91532 5.49747L1.41785 1"
        stroke={getPrimaryColor()}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );

  return (
    <div className="container max-screen-w-xl text-center p-10">
      <h1 className={styles.mainTitle}>{data.title}</h1>
      <h5 className={styles.mainSubTitle}>{data.subTitle}</h5>
      <div className=" my-5 grid grid-cols-1 md:grid-cols-2 text-left gap-5">
        {data.cards.map((v, i) => (
          <div className={`flex flex-col ${styles.cardContainer}`} key={i}>
            <div className={`${styles.roundedImage} ${styles.largeImageCard}`}>
              <NextImage media={v.image.data} />
            </div>
            <h5 className={`px-5 mt-4 ${styles.cardTitle}`}>{v.title}</h5>
            <small className={`px-5 ${styles.smallText}`}>{v.subTitle}</small>
            <p className={`grow px-5 ${styles.cardDescription}`}>
              {v.description}
            </p>
            <hr className="my-4 mx-5" />
            <p className="text-onmoPrimary text-right px-5 mb-4">
              {v.link === null ? null : (
                <>
                  <CustomLink link={v.link}>
                    <span className="underline underline-offset-2">
                      {v.link.text}
                    </span>{" "}
                    {arrow}
                  </CustomLink>{" "}
                </>
              )}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LargeImageCards;
